module.exports = __webpack_public_path__ + "static/media/GT05_AT_Room-Attributes.38019f5e.csv";